module.exports = __webpack_public_path__ + "static/media/rebirth_27.10f0a233.jpg";